const MedicalDeviceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M5.2207 5.2207L14.2598 9.74023M5.2207 5.2207V16.5195L14.2598 21.0391M5.2207 5.2207L9.74023 2.96094L18.7793 7.48047M14.2598 9.74023V21.0391M14.2598 9.74023L18.7793 7.48047M14.2598 21.0391L18.7793 18.7793V7.48047"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17.0913 17.1655L15.9614 17.7305M17.0913 15.5701L15.9614 16.135M17.0913 13.9746L15.9614 14.5396M17.0913 12.3792L15.9614 12.9441"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default MedicalDeviceIcon;
